import { ThemeOptions } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

export const themeOptions: ThemeOptions = {
  components: {
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          fontSize: '12px',
          padding: '8px 8px',
          minHeight: '24px',
          lineHeight: 1.2,
        },
        sizeMedium: {
          fontSize: '14px',
          padding: '12px 8px',
          minHeight: '24px',
          lineHeight: 1.4,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          padding: '8px',
          minHeight: '24px',
          lineHeight: 1.2,
          marginTop: '8px',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          minHeight: '40px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: '50%',
          transform: 'translate(14px, -50%) scale(1)',
          transformOrigin: 'top left',

          '&.MuiInputLabel-shrink': {
            top: 0,
            transform: 'translate(14px, -8px) scale(0.85)',
            fontSize: '12px',
          },
          '&.Mui-error:not(.MuiInputLabel-shrink)': {
            top: '35%',
            transform: 'translate(14px, -50%) scale(1)',
            color: 'error',
          },
          '&.MuiInputLabel-shrink.Mui-error': {
            top: 0,
            transform: 'translate(14px, -8px) scale(0.85)',
            color: 'error',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: 0,
            minHeight: '40px',
            height: '40px',
          },
        },
        input: {
          padding: '10px 12px !important',
          height: '40px',
          fontSize: '14px',
          boxSizing: 'border-box',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '0px 12px',
          height: '40px',
          lineHeight: '40px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '10px 16px',
          height: '40px',
          fontSize: '16px',
          boxSizing: 'border-box',
        },
      },
    },
  },

  typography: {
    fontFamily: [
      'Roboto',
      // '"Segoe UI"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
};
